/**
 * @override
 * 自定义积木，要采用统一样式，必须在定义积木样式，
 * 设置output:'String/Number/Boolean/...'
 *
 */
import Blockly from 'blockly'

// 事件类别基础积木
Blockly.Blocks["gta_ai_event_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true);
      this.setStyle("event_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};
Blockly.Python["gta_ai_event_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};

// 控制类别基础积木
Blockly.Blocks["gta_ai_controls_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true);
      this.setStyle("loop_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};

Blockly.Python["gta_ai_controls_item"] = function(block) {
  // TODO: Assemble Python into code variable.
  var code = "...";
  // TODO: Change ORDER_NONE to the correct strength.
  return [code, Blockly.Python.ORDER_NONE];
};

// 运算类别基础积木 #暂时没用到
Blockly.Blocks["gta_ai_math_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true);
      this.setStyle("math_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};

Blockly.Python["gta_ai_math_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};

// 文本基础积木
Blockly.Blocks["gta_ai_text_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true, "any");
      this.setStyle("text_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};

Blockly.Python["gta_ai_text_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};

// 列表基础积木
Blockly.Blocks["gta_ai_list_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true, "any");
      this.setStyle("list_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};
Blockly.Python["gta_ai_list_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};

// 我的模型基础积木
Blockly.Blocks["my_model_blocks_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true, "any");
      this.setStyle("my_model_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};
Blockly.Python["my_model_blocks_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};

// 公共模型基础积木
Blockly.Blocks["public_model_blocks_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true, "any");
      this.setStyle("public_model_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};
Blockly.Python["public_model_blocks_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};

// 实训模型基础积木
Blockly.Blocks["training_model_blocks_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true, "any");
      this.setStyle("training_model_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};
Blockly.Python["training_model_blocks_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};

// 基础模型基础积木
Blockly.Blocks["basic_model_blocks_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true, "any");
      this.setStyle("basic_model_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};
Blockly.Python["basic_model_blocks_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};

// 进阶模型基础积木
Blockly.Blocks["advanced_model_blocks_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true, "any");
      this.setStyle("advanced_model_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};
Blockly.Python["advanced_model_blocks_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};

// 人工智能基础积木
Blockly.Blocks["Intelligent_hardware_blocks_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true, "any");
      this.setStyle("Intelligent_hardware_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};
Blockly.Python["Intelligent_hardware_blocks_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};


// 新建积木基础积木 #暂时没用
Blockly.Blocks["custom_blocks_item"] = {
  init: function() {
      this.appendDummyInput().appendField(
          new Blockly.FieldLabelSerializable(""),
          "NAME"
      );
      this.setOutput(true, "any");
      this.setStyle("custom_blocks");
      this.setTooltip("");
      this.setInputsInline(true);
      this.setHelpUrl("");
  }
};
Blockly.Python["custom_blocks_item"] = function(block) {
  var code = "...";
  return [code, Blockly.Python.ORDER_NONE];
};